/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUrlaubsantragDto } from '../../models/update-urlaubsantrag-dto';
import { UrlaubsantragDto } from '../../models/urlaubsantrag-dto';

export interface UpdateUrlaubsantrag$Plain$Params {
  id: string;
      body?: UpdateUrlaubsantragDto
}

export function updateUrlaubsantrag$Plain(http: HttpClient, rootUrl: string, params: UpdateUrlaubsantrag$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsantragDto>> {
  const rb = new RequestBuilder(rootUrl, updateUrlaubsantrag$Plain.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UrlaubsantragDto>;
    })
  );
}

updateUrlaubsantrag$Plain.PATH = '/v1/urlaubsantraege/{id}';
